// @ts-check

import { api } from '@/api'
import { createResourceApi } from './helpers/createResourceApi'

/** @type {ResourceApi<BankAccountResource>} */
export const bankAccountApi = createResourceApi('bank-accounts')

export const getBankAccounts = bankAccountApi.index

export const getBankAccount = bankAccountApi.show

export const createBankAccount = bankAccountApi.store

export const updateBankAccount = bankAccountApi.update

export const deleteBankAccount = bankAccountApi.destroy

/**
 * @param {BankAccountResource['id']} accountId
 * @returns {Promise<BankAccountResource>}
 */
export const setBankAccountAsDefault = async (accountId) => {
  const res = await api.post(`bank-accounts/${accountId}/set-as-default`)
  return res.data
}

/**
 * @param {BankAccountResource['bank_connection_id']} connectionId
 * @returns {Promise<void>}
 */
export const disconnectBankAccount = (connectionId) =>
  api.delete(`integrations/psd2/accounts/${connectionId}`, {
    data: {
      confirm_delete_multiple: true
    }
  })

/**
 * @param {LocalizedPayload|undefined} params
 * @returns {Promise<RestrictionStatusResource>}
 */
export const getBankAccountCanConnect = async (params) => {
  const res = await api.get('bank-accounts/can-connect', { params })
  return res.data
}
